export enum AdminSkillApiErrorTypes {
  ServiceUnavailableError,
  NotFoundError,
  RequestValidationError,
}

export class AdminSkillApiError {
  constructor(public type: AdminSkillApiErrorTypes, public error: Error) {}
}
